import OrderServeType from '@/constants/OrderServeType';
import { cloneDeep, isEmpty } from 'lodash';

const checkStoreServeTypeConfig = (webStoreVo) => {
  const cloneWebStoreVo = cloneDeep(webStoreVo);
  const { dineInEnable, takeoutEnable, isDeliveryEnable, availableServeTypes } =
    cloneWebStoreVo || {};
  const cloneAvailableServeTypes = cloneDeep(availableServeTypes);
  const tempAvailableServeTypes: any = [];

  cloneAvailableServeTypes?.forEach((type) => {
    if (type === OrderServeType.DINE_IN && dineInEnable) {
      tempAvailableServeTypes.push(type);
    } else if (type === OrderServeType.TAKE_OUT && takeoutEnable) {
      tempAvailableServeTypes.push(type);
    } else if (type === OrderServeType.DELIVERY && isDeliveryEnable) {
      tempAvailableServeTypes.push(type);
    } else if (
      type !== OrderServeType.DINE_IN &&
      type !== OrderServeType.TAKE_OUT &&
      type !== OrderServeType.DELIVERY
    ) {
      tempAvailableServeTypes.push(type);
    }
  });
  return tempAvailableServeTypes;
};

export default checkStoreServeTypeConfig;
